// extracted by mini-css-extract-plugin
export default {"container":"Container_container__VVOCq","container__design":"Container_container__design__t7211"};